import { isEqual } from 'lodash';
import { useCallback, useState } from 'react';
import { Row } from 'react-table';

export const useRowSelection = () => {
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const onSelectedRowsChange = useCallback((rows: Row[]) => {
    setSelectedRows((prev) => {
      const newValue = rows.map((row) => row.id);
      if (isEqual(prev, newValue)) {
        return prev;
      }
      return newValue;
    });
  }, []);

  return { selectedRows, onSelectedRowsChange };
};
